<template>
    <div class="container">
        <img src="../../../static/images/index/t_bg.png" class="bgImg" alt="" />
        <div class="ticket-box">
            <img :src="imgcode" class="saveImg" v-if="imgcode"/>
            <div class="tb_real" ref="imageDom">
                <img src="../../../static/images/index/canvas_top.png" class="topImg" alt="" />
                <div class="tb_real_box">
                    <div class="no">预登记号：<b>{{info.RegistrationCode}}</b></div>
                    <div class="code" ref="qrCodeUrl"></div>
                    <div class="name">{{info.Name}}</div>
                    <div class="company">{{info.CompanyName}}</div>
                    <div class="time">
                        <p>展会时间：2025.06.09~2025.06.12</p>
                        <p>展会地点：中国广州海珠区阅江中路380号</p>
                    </div>
                </div>
                <img src="../../../static/images/index/canvas_btm.png" class="btmImg" alt="" />
            </div>
        </div>
        <div class="tips">长按图片保存</div>

        <div class="notice-box">
            <div>入场须知</div>
            <div>1. 进入展馆需凭本人实名登记后的电子胸卡入场。请携带身份证原件到场，以便核验。</div>
            <div>2. 主办单位将会核实阁下的专业观众身份，并保留拒绝向非专业观众或提供虚假资料人士发出专业观众证的权利。</div>
            <div>3. 持卡人必须遵从并接受主办单位安排的保安检查程序。</div>
            <div>4. 本届展会采用实名登记方式，一人一证，不得转让。暂不接受纸质证明与手机截图入场参展参观。</div>
            <div>5. 此展览只供18岁或以上的业内人士参观。</div>
        </div>
    </div>
</template>
<script>
    import { visitInfo } from "@/api/exhibition";
    import html2canvas from 'html2canvas';
    import QRCode from "qrcodejs2";
    export default {
        name: "ticket",
        components: {},
        data() {
            return {
                info: "",
                imgcode: "",
            };
        },
        computed: {

        },
        methods: {

        },
        mounted() {
            var that = this;
            // if(localStorage.getItem('mobile')){
                that.Common.showLoading("门票生成中…");
                visitInfo({
                    "Mobile": localStorage.getItem('mobile')
                }).then((res) => {
                    that.info = res.Data;
                    let qrcode = new QRCode(that.$refs.qrCodeUrl, {
                            width: 128, // 宽度
                            height: 128, // 高度
                            background: "#ffffff", // 背景色
                            foreground: "#000000", // 前景色
                            text: res.Data.RegistrationCode, // 二维码内容
                            render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                    });
                    this.$nextTick(() => {
                        html2canvas(that.$refs.imageDom, {
                            backgroundColor: "transparent", //设置透明背景
                            useCORS: true, // 【重要】开启跨域配置
                            allowTaint: true, //允许跨域图片
                            taintTest: false, //是否在渲染前测试图片
                        }).then((canvas) => {
                            let imgUrl = canvas.toDataURL("image/png");
                            that.imgcode = imgUrl;
                            setTimeout(function(){
                                that.Common.clearLoading();
                            }, 1000)
                        });
                    });
                }) 
            // }
        },
    };
</script>
<style scoped>
    .container{
        background-color: #0E1937;
        min-height: 100vh;
        box-sizing: border-box;
        padding: 20px 25px 50px 25px;
    }

    .bgImg {
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
    }

    /* 海报 */
    .ticket-box{
        position: relative;
    }
    
    .saveImg{
        position: absolute;
        z-index: 10;
        width: 100%;
        height: auto;
    }

    .tb_real{
        position: relative;
        min-height: 318px;
        padding: 23px 5px 0 5px;
    }

    .tb_real .topImg{
        position: absolute;
        width: 100%;
        height: auto;
        top: 0;
        left: 0;
    }

    .tb_real_box{
        position: relative;
        z-index: 1;
    }

    .tb_real .no{
        text-align: center;
        font-size: 15px;
        line-height: 18px;
        color: #EB4E4E;
    }

    .tb_real .code{
        margin: 14px auto 0;
        width: 128px;
        height: 128px;
    }

    .tb_real .name{
        text-align: center;
        font-size: 20px;
        min-height: 23px;
        line-height: 23px;
        font-weight: bold;
        color: #000000;
        margin-top: 10px;
    }

    .tb_real .company{
        text-align: center;
        font-size: 13px;
        min-height: 16px;
        line-height: 16px;
        height: 32px;
        color: #000000;
        margin-top: 9px;
    }

    .tb_real .time{
        margin-top: 18px;
    }

    .tb_real .time p{
        margin: 0 10px;
        font-size: 12px;
        line-height: 20px;
        color: #4E548A;
    }

    .tb_real .btmImg{
        position: absolute;
        width: 100%;
        height: auto;
        bottom: 0;
        left: 0;
    }
    
    .tips{
        margin-top: 10px;
        color: #cccccc;
        font-size: 12px;
        text-align: center;
        text-decoration: underline;
    }

    .notice-box {
        margin-top: 30px;
    }

    .notice-box div {
        color: #ffffff;
        font-size: 12px;
        line-height: 23px;
    }

    .notice-box div:first-child {
        position: relative;
        font-weight: bold;
        font-size: 18px;
        padding-left: 9px;
        margin-bottom: 10px;
    }

    .notice-box div:first-child::before {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        content: "";
        width: 5px;
        height: 18px;
        background: #CE1D64;
    }
</style>
  